import type * as ArticlePage from '../types/ArticlePage'
import type { RawComponent, Component } from '../../components/types'
import parseComponent from '../../components/parsers'
import articleHeaderComponentParser from '../../components/parsers/ArticleHeader'
import { socialMetaDataParser } from '.'

function parseArticlePageComponent(
  rawComponent: RawComponent,
  metaData: ArticlePage.MetaData,
): Component | undefined {
  switch (rawComponent.acfFcLayout) {
    case 'article_header':
      return articleHeaderComponentParser(rawComponent, metaData)
    default:
      return parseComponent(rawComponent)
  }
}

export default function articlePageParser(
  rawResponse: ArticlePage.Raw,
): ArticlePage.Parsed {
  const {
    acf,
    title,
    contentPublishDate,
    breadcrumbs,
    contentType,
    categoryLinks,
    cfdailyLinks,
  } = rawResponse.tiles[0]
  const { topicId, components, fullPath } = acf

  const commentTopics = [
    {
      title,
      topicId,
    },
  ]

  const metaData = {
    breadcrumbs,
    contentPublishDate,
    contentType,
    commentTopics,
    title,
    topicId,
    socialMetaData: socialMetaDataParser(rawResponse),
    categoryLinks,
    cfdailyLinks,
    path: fullPath,
  }

  return {
    ...metaData,
    components: components
      .map((component) => parseArticlePageComponent(component, metaData))
      .filter((component): component is Component => !!component),
  }
}
